module.exports = __webpack_public_path__ + "static/media/GalleryImage13.de6febab.jpg";